import React from 'react'
const Message = () => {
	return(
		<div className='title'>
			<h1><a href='https://parceljs.org/' target='_blank' className='link'>Parcel</a> & 
			<a href='https://es.reactjs.org/' target='_blank' className='link'> React</a></h1>
			<p>Fast and easier</p>
		</div>
	)
};
export default Message